import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 101 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i2067593348__a)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-rule": "evenodd",
        d: "M7.53 7.03C.5 14.058.5 25.372.5 48v4c0 22.627 0 33.941 7.03 40.97C14.558 100 25.872 100 48.5 100h4c22.627 0 33.941 0 40.97-7.03 7.03-7.029 7.03-18.343 7.03-40.97v-4c0-22.627 0-33.941-7.03-40.97C86.442 0 75.128 0 52.5 0h-4C25.873 0 14.559 0 7.53 7.03Zm9.845 23.387c.542 26 13.542 41.625 36.333 41.625H55V57.167c8.375.833 14.708 6.958 17.25 14.875h11.834c-3.25-11.834-11.793-18.375-17.126-20.875 5.333-3.084 12.834-10.584 14.625-20.75h-10.75c-2.334 8.25-9.25 15.75-15.833 16.458V30.417H44.25V59.25c-6.667-1.666-15.083-9.75-15.458-28.833H17.375Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i2067593348__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.5 0h100v100H.5z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "vk"}) } }